require('../modules/web.url');
require('../modules/web.url.to-json');
require('../modules/web.url-search-params');
var path = require('../internals/path');

module.exports = path.URL;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/web/url.js
// module id = 1309
// module chunks = 1